const events = {
    facebook: {
        analyticsName: 'other.visit-finn-facebook.click',
        eventFlags: 'start,ltp',
    },
    twitter: {
        analyticsName: 'other.visit-finn-twitter.click',
        eventFlags: 'start,ltp',
    },
    instagram: {
        analyticsName: 'other.visit-finn-instagram.click',
        eventFlags: 'start,ltp',
    },
    youtube: {
        analyticsName: 'other.visit-finn-youtube.click',
        eventFlags: 'start,ltp',
    },
    jobbifinn: {
        analyticsName: 'other.visit-finn-jobbifinn.click',
        eventFlags: 'start,ltp',
    },
    bedriftskunde: {
        analyticsName: 'other.visit-finn-bedriftskunde.click',
        eventFlags: 'start,success',
    },
    admin: {
        analyticsName: 'other.visit-finn-admin.click',
        eventFlags: 'start,success',
    },
    nativeads: {
        analyticsName: 'other.visit-finn-nativeads.click',
        eventFlags: 'start,ltp',
    },
    omfinn: {
        analyticsName: 'other.visit-finn-omfinn.click',
        eventFlags: 'start,ltp',
    },
    personvern: {
        analyticsName: 'other.visit-finn-personvern.click',
        eventFlags: 'start,ltp',
    },
    innstillinger_personvern: {
        analyticsName: 'other.visit-finn-innstillinger-for-personvern.click',
        eventFlags: 'start,ltp',
    },
    cookie: {
        analyticsName: 'other.visit-finn-cookies.click',
        eventFlags: 'start,ltp',
    },
    hjelp: {
        analyticsName: 'other.visit-finn-hjelp.click',
        eventFlags: 'start,ltp',
    },
};

function trackInteraction(evt) {
    // @ts-ignore
    if (window.finnAnalytics) {
        const el = evt.target.closest('[data-some-provider]');
        if (el) {
            const provider = el.getAttribute('data-some-provider');
            if (events[provider]) {
                // @ts-ignore
                window.finnAnalytics.trackEvent(events[provider]);
            }
        }
    }
}

document
    .querySelector('finn-footer')
    ?.shadowRoot?.querySelector('[data-some-footer-tracking]')
    ?.addEventListener('click', trackInteraction);
